import React from 'react';
import { useTranslation } from 'react-i18next';
import _isEmpty from 'lodash.isempty';
import _omit from 'lodash.omit';

import CompanyDataCard, { CompanyDataRow } from 'components/reusable/CompanyDataCard';

import { Col, Divider, Typography } from 'antd';
import { ReactComponent as ContactInfo } from 'assets/img/icons/cardIcons/contactInfo.svg';
import { Link } from 'react-router-dom';

const { Text } = Typography;

const CompanyContactInformation = ({ contactData, setUpdateModalOpen, type = 'regular', children }) => {
  const { t } = useTranslation();

  const concatCompanyContactValues = () => {
    const fields =
      type === 'regular'
        ? [
            {
              title: t('professionalReport.basicData.contactInformation.address'),
              value: contactData?.address ?? '-',
            },
            {
              title: t('professionalReport.basicData.contactInformation.email'),
              value: contactData?.email ?? '-',
            },
            {
              title: t('professionalReport.basicData.contactInformation.visitAddress'),
              value: contactData?.visitAddress ?? '-',
            },
            {
              title: t('professionalReport.basicData.contactInformation.uri'),
              value: contactData?.uri ?? '-',
            },
            {
              title: t('professionalReport.basicData.contactInformation.phone'),
              value: contactData?.phone ?? '-',
            },
            {
              title: t('professionalReport.basicData.contactInformation.iban'),
              value: contactData?.iban ?? '-',
            },
            {
              title: t('professionalReport.basicData.contactInformation.mobile'),
              value: contactData?.mobile ?? '-',
            },
            {
              title: t('professionalReport.basicData.contactInformation.bank'),
              value: contactData?.bank ?? '-',
            },
          ]
        : [
            {
              title: t('professionalReport.basicData.rekvizitaiContactInformation.address'),
              value: contactData?.address ?? '-',
            },
            {
              title: t('professionalReport.basicData.rekvizitaiContactInformation.cellPhone'),
              value: contactData?.cellPhone ?? '-',
            },
            {
              title: t('professionalReport.basicData.rekvizitaiContactInformation.email'),
              value: contactData?.email ?? '-',
            },
            {
              title: t('professionalReport.basicData.rekvizitaiContactInformation.phone'),
              value: contactData?.phone ?? '-',
            },
            {
              title: t('professionalReport.basicData.rekvizitaiContactInformation.uri'),
              value: contactData?.uri ?? '-',
            },
            {
              title: t('professionalReport.basicData.rekvizitaiContactInformation.iban'),
              value: contactData?.iban ?? '-',
            },
          ];

    return fields.map(row => `${row.title} - ${row.value}`).join('\r\n');
  };

  return (
    <Col
      xs={{ span: 24, order: 1 }}
      sm={{ span: 24, order: 1 }}
      md={{ span: 24, order: 1 }}
      lg={{ span: 12, order: 1 }}
      xl={{ span: 12, order: 1 }}
      xxl={{ span: 12, order: 1 }}
      className="flex"
    >
      {type === 'regular' ? (
        <CompanyDataCard
          icon={<ContactInfo className="title-icon" />}
          title={<span>{t('professionalReport.basicData.contactInformation.title')}</span>}
          copyData={concatCompanyContactValues()}
        >
          {_isEmpty(contactData) ? (
            t('global.noInformation')
          ) : (
            <>
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.contactInformation.address')}
                value={contactData?.address ?? '-'}
              />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.contactInformation.visitAddress')}
                value={contactData?.visitAddress ?? '-'}
              />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.contactInformation.phone')}
                value={contactData?.phone ?? '-'}
              />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.contactInformation.mobile')}
                value={contactData?.mobile ?? '-'}
              />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.contactInformation.email')}
                value={contactData?.email ?? '-'}
              />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.contactInformation.uri')}
                value={
                  contactData?.uri ? (
                    <Link href={contactData?.uri} target="_blank" rel="noopener noreferrer">
                      <Text className="underlined">{contactData?.uri}</Text>
                    </Link>
                  ) : (
                    '-'
                  )
                }
              />
              <Divider className="space-vertical-xs" />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.contactInformation.iban')}
                value={contactData?.iban ?? '-'}
              />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.contactInformation.bank')}
                value={contactData?.bank ?? '-'}
              />
            </>
          )}
          {children}
        </CompanyDataCard>
      ) : (
        <CompanyDataCard
          icon={<ContactInfo className="title-icon" />}
          title={t('professionalReport.basicData.rekvizitaiContactInformation.title')}
          copyData={concatCompanyContactValues()}
        >
          {_isEmpty(_omit(contactData, ['creditinfoId', 'companyCode'])) ? (
            t('global.noInformation')
          ) : (
            <>
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.rekvizitaiContactInformation.address')}
                value={contactData?.address ?? '-'}
              />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.rekvizitaiContactInformation.cellPhone')}
                value={contactData?.cellPhone ?? '-'}
              />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.rekvizitaiContactInformation.phone')}
                value={contactData?.phone ?? '-'}
              />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.rekvizitaiContactInformation.email')}
                value={contactData?.email ?? '-'}
              />
              <Divider className="space-vertical-xs" />
              <CompanyDataRow
                halfBlock
                type={t('professionalReport.basicData.rekvizitaiContactInformation.uri')}
                value={
                  contactData?.uri ? (
                    <Link href={contactData?.uri} target="_blank" rel="noopener noreferrer">
                      <Text className="underlined">{contactData?.uri}</Text>
                    </Link>
                  ) : (
                    '-'
                  )
                }
              />
            </>
          )}
          {children}
        </CompanyDataCard>
      )}
    </Col>
  );
};

export default CompanyContactInformation;
